<!-- Email input field -->
<span class="input-group">
  <!-- Enter Icon -->
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" (click)="enter(emailInput.value)"
    class="suffix" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none">
      <rect width="24" height="24" fill="#FFF"/>
      <path d="M17 4L17 13C17 15.2 15.2 17 13 17L5 17M9 13L5 17 9 21" 
        [attr.stroke]="emailInput.value && !isError && !isTyping ? '#64C2E6' : '#ACB4BB'"/>
    </g>
  </svg>
  <!-- /.Enter Icon -->
  <input placeholder="sample@email.com" type="email" name="email" autocomplete="off" (keyup.enter)="enter(emailInput.value)"(ngModelChange)="onChangeEmail($event)" #emailInput ngModel>
</span>
<!-- /.Email input field -->

<!-- Message -->
<div class="msg-container">
  <span class="error-msg" [class.show-error-msg]="isError" id="warning-msg">{{errMsg}}</span>
  <span class="info-msg" *ngIf="!isError" [class.show-info-msg]="isValid">Press enter after you insert the email</span>
</div>
<!-- /.Message -->